<div class="detail-card">
  <div class="close" (click)="closeExchangeForm(); $event.stopPropagation()">
    <img src="assets/icons/news/close.svg" alt="close modal" />
  </div>
  <div class="bundle-percentage">
    <div class="header">
      <img [src]="'/assets/icons/crypto/bundles/' + ticker + '.svg'" alt="" class="icon" />
      <p class="name">
        Canasta | <span>{{ this.bundle.name }}</span>
      </p>
    </div>
    <div class="items" [class.three]="bundle.coins.length === 3">
      <div class="item" *ngFor="let coin of bundle.coins; let index = index">
        <svg
          width="100%"
          height="150"
          viewBox="0 0 394 194"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          *ngIf="bundle.coins.length === 3 && index === 0"
          [style.transform]="getSVGDeg(bundle.coins.length, index)"
        >
          <path
            class="form"
            (mouseover)="hovered = true; hoveredIndex = index; hoveredTicker = coin.ticker"
            (mouseleave)="hovered = false; hoveredTicker = ''"
            d="M66.8309 186.485C66.3432 190.691 62.8679 194 58.6332 194L7.84888 194C3.35413 194 -0.27417 190.288 0.0166314 185.802C6.74355 82.0505 92.2087 2.63224e-05 196.651 1.93298e-06C301.093 -2.24565e-05 386.559 82.0504 393.286 185.802C393.576 190.288 389.948 194 385.453 194L334.669 194C330.435 194 326.959 190.691 326.472 186.485C318.867 120.894 263.645 70 196.651 70C129.658 70 74.4357 120.895 66.8309 186.485Z"
            [style.fill]="
              hovered && index === hoveredIndex
                ? colorPaletteByBundle(ticker, 'circle')
                : colorPaletteByBundle(ticker, 'main')
            "
            [style.cursor]="'pointer'"
          />
        </svg>

        <svg
          width="150"
          height="150"
          viewBox="0 0 189 189"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          *ngIf="bundle.coins.length > 3 || (bundle.coins.length === 3 && index > 0)"
          [style.transform]="getSVGDeg(bundle.coins.length, index)"
        >
          <path
            class="form"
            (mouseover)="hovered = true; hoveredIndex = index; hoveredTicker = coin.ticker"
            (mouseleave)="hovered = false; hoveredTicker = ''"
            [style.fill]="
              hovered && index === hoveredIndex
                ? colorPaletteByBundle(ticker, 'circle')
                : colorPaletteByBundle(ticker, 'main')
            "
            [style.cursor]="'pointer'"
            d="M2.46548e-05 8.30533C2.54479e-05 3.76922 3.77519 0.125066 8.29727 0.481637C105.37 8.13594 182.603 85.052 188.984 181.006C189.275 185.38 185.646 188.999 181.152 188.999L130.367 188.999C126.132 188.999 122.657 185.773 122.17 181.672C115.148 122.627 67.5307 75.7967 7.53545 68.9624C3.32074 68.4823 1.47413e-05 65.0036 1.5483e-05 60.7617L2.46548e-05 8.30533Z"
            fill="#960505"
          />
        </svg>

        <img
          class="icon"
          #icon
          [style]="getIconPosition(bundle.coins.length, index)"
          (mouseover)="hovered = true; hoveredIndex = index; hoveredTicker = coin.ticker"
          (mouseleave)="hovered = false; hoveredTicker = ''"
          [src]="getIconSrc(coin.ticker, index)"
          alt=""
        />
      </div>
      <div class="info" [class.hide]="hovered">
        <p class="label">Últ. 7 días</p>
        <p class="amount" [class.up]="variation > 0" [class.down]="variation < 0">
          <span *ngIf="variation !== 0">
            <svg
              [class.up]="variation > 0"
              width="9"
              height="6"
              viewBox="0 0 9 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M4.50001 6L-5.24537e-07 7.86805e-07L9 0L4.50001 6Z" fill="#f97c7c" />
            </svg>
          </span>
          {{ variation | number : '0.2-2' }}%
        </p>
      </div>
      <div class="info" [class.hide]="!hovered">
        <p class="label">{{ getCoinFullName(hoveredTicker) }}</p>
        <p class="percentage">Porcentaje en el paquete:</p>
        <p class="amount">{{ getCoinPercentage(hoveredTicker) }}%</p>
      </div>
    </div>
  </div>

  <div class="bundle-operation">
    <div class="info">
      <p class="title">Descripción</p>
      <p class="description">
        {{ getBundleDescription(bundle.ticker) }}
      </p>
    </div>
    <div class="operation">
      <!-- <div class="choice" *ngIf="bundle.ticker !== 'BNDL-RCHAIN' && bundle.ticker !== 'BNDL-CONS'">
        <div
          class="circle"
          [class.isBuying]="isBuying"
          [style.background]="colorPaletteByBundle(ticker, 'main')"
        ></div>
        <div class="pill" [ngClass]="{ active: isBuying }" (click)="isBuying = true">
          <p
            [class.active]="isBuying"
            [style.color]="isBuying ? colorPaletteByBundle(ticker, 'accent') : '#FFFFFF'"
          >
            Comprar
          </p>
        </div>
        <div class="pill" [ngClass]="{ active: !isBuying }" (click)="isBuying = false">
          <p
            [class.active]="!isBuying"
            [style.color]="!isBuying ? colorPaletteByBundle(ticker, 'accent') : '#FFFFFF'"
          >
            Vender
          </p>
        </div>
      </div> -->
      <div class="form-container">
        <div class="input-container">
          <input
            type="text"
            placeholder="0.00"
            [mask]="'separator.3'"
            thousandSeparator="."
            [formControl]="operateQuantity"
            (change)="onQuantityChange()"
            (blur)="($event.preventDefault)"
            (keyup.enter)="createOrder()"
          />
          <span
            class="max-btn"
            (click)="setMaxAmount()"
            [style.color]="colorPaletteByBundle(ticker, 'main')"
            >MAX</span
          >
        </div>
        <p class="balance">Fondos disponibles: {{ getAvailableFund() | currency : 'AR$' }}</p>
        <div class="separator"></div>
        <div class="order-summary">
          <p class="title">Resumen de {{ isBuying ? 'compra' : 'venta' }}</p>
          <div class="summary">
            <div class="item" *ngFor="let coin of this.bundle.coins">
              <p class="name">
                {{ coin.ticker }}
              </p>
              <p class="value">
                {{
                  getValueByTicker(coin.ticker, coin.percentage) | formatCoinAmount : coin.ticker
                }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <button
        *ngIf="!creatingOrder && !(isBuying && isBuyingDisabled)"
        (click)="createOrder()"
        [style.color]="colorPaletteByBundle(ticker, 'accent')"
        [style.background]="colorPaletteByBundle(ticker, 'main')"
      >
        {{ isBuying ? 'Comprar' : 'Vender' }}
      </button>
      <div class="loading" *ngIf="creatingOrder">
        <div
          class="checkmark draw"
          [style.borderTopColor]="colorPaletteByBundle(ticker, 'main')"
          [style.borderRightColor]="colorPaletteByBundle(ticker, 'main')"
        ></div>
        <div
          class="circle-loader"
          [style.borderLeftColor]="colorPaletteByBundle(ticker, 'main')"
        ></div>
      </div>
    </div>
  </div>
</div>
